/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';
import { getComponentStylesFactory } from '@/utils/getComponentStylesFactory';
import { getComponentThemeFactory } from '@/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "front_page": {
    "content_variant_vertical": "flex flex-col gap-3",
    "content_size_vertical": "",
    "media_video_size_default": "w-full",
    "media_image_size_default": "w-full",
    "content_title_size_vertical": "text-headline-sm grid-cols-7:text-headline-sm sm:text-headline sm:grid-cols-4:text-headline-lg sm:grid-cols-7:text-headline-lg",
    "variant_vertical": "grid-container",
    "size_vertical": "w-full not-prose",
    "content_hint_variant_vertical": "break-words",
    "content_hint_size_vertical": "text-body-sm grid-cols-7:text-body-sm sm:text-body"
  },
  "video_pages": {
    "content_variant_vertical": "flex flex-col gap-3",
    "content_size_vertical": "",
    "content_size_horizontal": "",
    "media_video_size_horizontal": "w-full max-w-[310px] max-h-[180px] aspect-video rounded-md",
    "media_image_size_vertical": "w-full max-w-[160px] max-h-[285px] md:max-w-[310px] md:max-h-[540px] aspect-vertical",
    "media_image_variant_vertical": "object-cover",
    "media_playIcon_variant_vertical": "absolute left-1/2 top-auto transform bottom-3 transform -translate-x-1/2 hidden",
    "content_title_size_vertical": "text-headline-sm grid-cols-7:text-headline sm:text-headline sm:grid-cols-4:text-headline-lg sm:grid-cols-7:text-headline-xl break-words line-clamp-3",
    "variant_vertical": "grid-container",
    "size_vertical": "w-full not-prose"
  },
  "tag": {
    "variant_default": "",
    "colors_text": "text-gray-600",
    "size_text": "text-headline-xs group-[.bg]/box:mx-4",
    "variant_text": "break-words capitalize"
  },
  "headline_variant_default": "",
  "headline_variant_horizontal": "",
  "headline_variant_vertical": "",
  "headline_size_default": "mb-1 text-headline-xs",
  "headline_size_horizontal": "",
  "headline_size_vertical": "",
  "headline_colors_default": "",
  "headline_colors_primary": "",
  "headline_colors_secondary": "",
  "headline_line_variant_default": "",
  "headline_line_variant_vertical": "",
  "headline_line_variant_horizontal": "",
  "headline_line_colors_default": "after:bg-black",
  "headline_line_colors_primary": "",
  "headline_line_colors_secondary": "",
  "headline_line_size_default": "",
  "headline_line_size_vertical": "after:ml-1.5 after:flex-1 after:h-px",
  "headline_line_size_horizontal": "after:ml-1.5 after:flex-1 after:h-px",
  "content_size_default": "",
  "content_size_vertical": "p-3 border-l-4",
  "content_size_horizontal": "p-3 gap-3",
  "content_colors_default": "",
  "content_colors_primary": "bg-white shadow-black/5",
  "content_colors_secondary": "border-primary-900 bg-gray-100",
  "content_variant_default": "",
  "content_variant_horizontal": "flex shadow-[0px_0px_7px_2px]",
  "content_variant_vertical": "flex flex-col md:flex-row gap-3",
  "content_title_variant_default": "",
  "content_title_variant_horizontal": "break-words",
  "content_title_variant_vertical": "",
  "content_title_size_default": "",
  "content_title_size_horizontal": "text-headline-xs md:text-headline",
  "content_title_size_vertical": "text-headline-sm",
  "content_title_colors_default": "",
  "content_title_colors_secondary": "text-white",
  "content_title_colors_primary": "text-black",
  "content_text_variant_default": "flex flex-col items-start",
  "content_text_variant_horizontal": "",
  "content_text_variant_vertical": "",
  "content_text_size_default": "gap-3",
  "content_text_size_horizontal": "",
  "content_text_size_vertical": "gap-0.5",
  "content_text_colors_default": "",
  "content_text_colors_primary": "",
  "content_text_colors_secondary": "",
  "content_hint_variant_default": "font-bold",
  "content_hint_variant_horizontal": "underline break-words",
  "content_hint_variant_vertical": "",
  "content_hint_colors_default": "",
  "content_hint_colors_primary": "text-cherry-blossom-500",
  "content_hint_colors_secondary": "text-black",
  "content_hint_size_vertical": "",
  "content_hint_size_horizontal": "text-headline-xs",
  "content_hint_size_default": "text-headline-xs md:text-headline-sm",
  "media_variant_default": "",
  "media_variant_vertical": "grow-0 shrink-0 relative",
  "media_variant_horizontal": "relative flex overflow-hidden grow-0 shrink-0",
  "media_size_default": "",
  "media_size_vertical": "rounded-lg h-fit",
  "media_size_horizontal": "basis-[156px] md:basis-[200px]",
  "media_colors_default": "",
  "media_colors_primary": "",
  "media_colors_secondary": "",
  "media_video_variant_default": "",
  "media_video_variant_horizontal": "",
  "media_video_variant_vertical": "",
  "media_video_size_default": "w-full",
  "media_video_size_horizontal": "w-full",
  "media_video_size_vertical": "w-full",
  "media_video_colors_default": "",
  "media_video_colors_primary": "",
  "media_video_colors_secondary": "",
  "media_image_variant_default": "",
  "media_image_variant_horizontal": "",
  "media_image_variant_vertical": "",
  "media_image_size_default": "w-full",
  "media_image_size_horizontal": "w-full",
  "media_image_size_vertical": "w-full",
  "media_image_colors_default": "",
  "media_image_colors_primary": "",
  "media_image_colors_secondary": "",
  "media_playIcon_size_default": "w-9",
  "media_playIcon_size_vertical": "w-9",
  "media_playIcon_size_horizontal": "",
  "media_playIcon_variant_default": "",
  "media_playIcon_variant_horizontal": "absolute left-2 bottom-2",
  "media_playIcon_variant_vertical": "absolute left-3 top-3",
  "media_playIcon_colors_default": "",
  "media_playIcon_colors_primary": "",
  "media_playIcon_colors_secondary": "",
  "media_icon_colors_default": "",
  "media_icon_colors_primary": "text-cherry-blossom-300 [&>path:last-of-type]:fill-white",
  "media_icon_colors_secondary": "text-primary-300 [&>symbol>path]:fill-white",
  "media_icon_size_default": "",
  "media_icon_size_vertical": "",
  "media_icon_size_horizontal": "",
  "media_icon_variant_default": "",
  "media_icon_variant_horizontal": "",
  "media_icon_variant_vertical": "",
  "variant_horizontal": "grid-container",
  "colors_default": "",
  "colors_primary": "",
  "colors_secondary": "",
  "size_horizontal": "w-full not-prose"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "JwVideoTeaser");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;